
<template>
  <div class="driver">
    <div class="driver-header">
      <div class="search">
        <img alt="驱动精灵" class="searchImg" src="../assets/search_logo.png" />
        <div class="searchInput">
          <el-input :clearable="true" maxlength="50" placeholder="请输入内容,最多50个字符" v-model="keyword">
            <i class="el-input__icon el-icon-search" slot="prefix"></i>
            <el-button @click.stop="searchHandler" slot="append" type="success">搜索</el-button>
            <!-- <i class="el-input__icon el-icon-circle-close" slot="suffix"></i> -->
          </el-input>
        </div>
      </div>
    </div>
    <template v-if="!hasError">
      <div class="driver-body">
        <ul v-if="showList">
          <li :key="index" v-for="(item,index) in drivers">
            <span class="item item-img">
              <img :src="item.logo" style="width:100%;" v-if="item.logo" />
              <img src="../assets/printer_logo.png" v-else />
            </span>
            <div class="item item-title-desc">
              <p class="title">{{item.brand_cn}}{{item.brand_en}}</p>
              <p class="desc">{{Array.isArray(item.os_str)?item.os_str.join(' / '):item.os_str}}</p>
            </div>
            <span class="item item-ip">{{item.version}}</span>
            <span class="item item-size">{{item.exe_filesize|unitTransformation}}</span>
            <span @click="downloadReport(item)" class="item item-download">
              <a :href="item.exe_fileurl" download>下载</a>
            </span>
          </li>
        </ul>
        <div class="noData" v-if="!showList">
          <img src="../assets/noData_logo.png" />
          <p>暂无结果，可尝试精简搜索词，如搜品牌或相近型号</p>
        </div>
      </div>
      <div class="driver-footer" v-if="showList&&drivers.length>0">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          next-text="下一页"
          prev-text="上一页"
        ></el-pagination>
      </div>
    </template>
    <template v-else>
      <div class="error" v-if="!showList">
        <img src="../assets/error_logo.png" />
        <p>暂无结果，搜索遇到错误</p>
      </div>
    </template>
  </div>
</template>

<script>
import { parseQueryString, bytesToSize } from '../utils/common'
import { getData } from '../api/drivers'
import Report from '../utils/report'
export default {
  data() {
    return {
      hasError: false,
      showList: true,
      keyword: '',
      common: {
        uid: '',
        request_id: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      drivers: [],
      reportHandler: '',
      // 上报字段，来源于客户端
      source: '',
      trynum: '',
      pid: '',
    }
  },
  mounted() {
    // 1. get url params
    let params = parseQueryString()
    // 2. construt request data
    this.common.uid = params.uuid ? params.uuid : ''
    this.common.request_id = params.request_id ? params.uid : ''
    // this.keyword = params.keyword ? decodeURI(params.keyword) : ''
    this.keyword = params.keyword ? params.keyword : ''
    console.log('decodeURI---', this.keyword)
    // 上报信息
    this.source = params.source ? params.source : ''
    this.trynum = params.trynum ? params.trynum : ''
    this.pid = params.pid ? params.pid : ''
    this.reportHandler = new Report()
    if (params.keyword) {
      this.initList()
    } else {
      this.showList = false
    }
    document.addEventListener('keydown', this.enterHandler)
  },
  methods: {
    /**
     * 初始化上报
     */
    initReport() {
      let reportData = {
        business_index: 789, // duba_print_searchweb
        act: 1, //网页状态：1访问 ，2点击搜索，3点击常见问题
        words: this.keyword || '', // 搜索词
        source: this.source || 0, // 常见问题文案
        uuid: this.common.uid,
        trynum: this.trynum || 0,
        pid: this.pid || 0,
        page: this.currentPage,
        max: this.total,
        ver: 1, // 首版
        printname: '',
      }
      this.reportHandler.showToReport(reportData)
    },
    /**
     * 搜索上报
     */
    searchReprot() {
      let reportData = {
        business_index: 789, // duba_print_searchweb
        act: 2, //网页状态：1访问 ，2点击搜索，3点击常见问题
        words: this.keyword, // 搜索词
        source: this.source || 0, // 常见问题文案
        uuid: this.common.uid,
        trynum: this.trynum || 0,
        pid: this.pid || 0,
        page: 0,
        max: 0,
        ver: 1,
        printname: '',
      }
      this.reportHandler.clickToReport(reportData) // 点击上报
    },

    /**
     * 下载上报
     */
    downloadReport(item) {
      let reportData = {
        business_index: 789, // duba_print_searchweb
        act: 3, //网页状态：1访问 ，2点击搜索，3点击常见问题
        words: this.keyword, // 搜索词
        source: this.source || 0, // 常见问题文案
        uuid: this.common.uid,
        trynum: this.trynum || 0,
        pid: this.pid || 0,
        page: 0,
        max: 0,
        ver: 1,
        printname: item.exe_filename,
      }
      this.reportHandler.clickToReport(reportData)
    },
    /**
     * 分页
     */
    async handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      await this.getList()
      this.initReport()
    },
    /**
     * 搜素事件处理程序
     */
    async searchHandler() {
      if (this.keyword) {
        this.currentPage = 1 // 搜索之前要进行重置currentPage
        await this.getList()
        this.searchReprot()
        this.initReport()
      }
    },
    /**
     * 搜索列表
     */
    getList() {
      let requestData = {
        common: this.common,
        keyword: this.keyword,
        offset: (this.currentPage - 1) * this.pageSize,
        size: this.pageSize,
      }
      return getData(requestData)
        .then((res) => {
          if (res) {
            this.hasError = false
            this.drivers = res.items
            this.total = res.total
            if (this.drivers.length > 0) {
              this.showList = true
            } else {
              this.showList = false
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.hasError = true
        })
    },
    /**
     * 初始化列表
     */
    initList() {
      let requestData = {
        common: this.common,
        keyword: this.keyword,
        offset: (this.currentPage - 1) * this.pageSize,
        size: this.pageSize,
      }
      getData(requestData).then((res) => {
        if (res) {
          this.drivers = res.items
          this.total = res.total
          if (this.drivers.length > 0) {
            this.showList = true
          } else {
            this.showList = false
          }
          this.initReport()
        }
      })
    },
    /**
     * enter 事件处理程序
     */
    enterHandler(e) {
      let key = e.keyCode
      if (key === 13) {
        this.searchHandler()
      }
    },
  },
  filters: {
    unitTransformation(v) {
      if (v) {
        return bytesToSize(v)
      } else {
        return v
      }
    },
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.enterHandler)
  },
}
</script>
<style lang="scss" scoped>
$contentWidth: 980px;

.driver {
  background: #ffffff;
  .driver-header {
    .search {
      width: $contentWidth;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 130px;
      .searchImg {
        height: 50px;
        width: 165px;
        margin-right: 40px;
      }
      .searchInput {
        flex: 1;
        & ::v-deep .el-input-group__append {
          border-radius: 0px;
          border: 1px solid rgba(38, 202, 1, 1);
          .el-button--success {
            background: rgba(38, 202, 1, 1);
            color: #ffffff;
            border-radius: 0;
          }
        }
        & ::v-deep .el-input__icon {
          font-size: 18px;
        }
        .el-icon-search {
          font-size: 0;
          background: url(../assets/search.png) 4px 11px no-repeat;
        }
        & ::v-deep .el-input__suffix {
          .el-icon-circle-close {
            content: '';
            font-size: 0;
            background: url(../assets/close.png) 4px 11px no-repeat;
          }
        }
        
      }
    }
    box-shadow: 0 1px 2px 0 #e5e5e5;
  }
  .driver-body {
    width: $contentWidth;
    margin: 0 auto;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .item {
        color: rgba(187, 187, 187, 1);
        font-size: 12px;
        display: block;
      }
      .item-img {
        width: 80px;
        margin-right: 16px;
      }
      .item-title-desc {
        line-height: 16px;
        text-align: left;
        flex: 1;
        .title {
          color: #666666ff;
          margin-bottom: 4px;
        }
      }
      .item-ip {
        min-width: 72px;
        margin-right: 51px;
      }
      .item-size {
        min-width: 51px;
        margin-right: 51px;
      }
      .item-download {
        display: block;
        width: 86px;
        height: 26px;
        line-height: 26px;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 2px;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
        a {
          display: block;
          width: 100%;
          height: 100%;
        }
        &:hover {
          color: #409eff;
          border-color: #409eff;
        }
      }
      &:nth-child(1) {
        margin-top: 50px;
      }
    }
    .noData,
    .err {
      color: rgba(153, 153, 153, 1);
      line-height: 16px;
      font-size: 12px;
      margin: 110px 0px;
    }
  }
  .driver-footer {
    margin-bottom: 68px;
    &::v-deep .el-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &::v-deep .el-pager li {
      width: 30px;
      height: 30px;
      background: rgba(249, 249, 249, 1);
      border-radius: 2px;
      border: 1px solid rgba(229, 229, 229, 1);
      margin: 0 4px;
      font-weight: normal;
      &.el-icon-more {
        content: '';
        font-size: 0;
        background: url(../assets/more.png) 9px 7px no-repeat;
      }
      &.el-icon-d-arrow-right {
        content: '';
        font-size: 0;
        background: url(../assets/nev.png) 9px 7px no-repeat;
      }
      &.el-icon-d-arrow-left {
        content: '';
        font-size: 0;
        background: url(../assets/pre.png) 9px 7px no-repeat;
      }
    }
  }
  .error {
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    font-size: 12px;
    margin: 110px 0px;
  }
}
</style>